import { useEffect, useMemo, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { getDashboardCount } from "../../api/itinerary.api";
import { getDashboardTabsData } from "../../api/quotation.api";
import { AddNewLeadsIconSvg, TotalQuotationsIconSvg, TotalBookingsIconSvg, SearchIconSvg, TotalEnquiriesIconSvg, TotalPendingsIconSvg } from "../../assets/svg";
import AnalyticBox from "../../components/Analytic/AnalyticBox";
import EnquiryTableRow from "./EnquiryTableRow";
import LeadsTableRow from "./LeadTableRow";
import BookingTableRow from "./BookingTableRow";
import { debounce } from "lodash";
import "./Dashboard.scss";
import React from "react";
import CustomPagination from "../../components/CustomPagination/Pagination";
import { scrollToTop } from "../../utils/scrollToTop";

const initialData = [
  { icon: <AddNewLeadsIconSvg fill="#fff" />, count: "", label: "Add New Leads", route: '/add-leads', isActive: true },
  { icon: <TotalEnquiriesIconSvg />, count: "0", label: "Total Enquiries", route: 'enquiry', isActive: false },
  { icon: <TotalQuotationsIconSvg />, count: "0", label: "Total Quotations", route: 'quotation', isActive: false },
  { icon: <TotalBookingsIconSvg />, count: "0", label: "Total Bookings", route: 'booking', isActive: false },
  { icon: <TotalPendingsIconSvg />, count: "0", label: "Total Pending", route: '', isActive: false },
  // { icon: <TotalPendingsIconSvg />, count: "0", label: "Total Pending", route: '/tasks-status', isActive: false },
  // { icon: <CancelledBookingsIconSvg />, count: "12", label: "Cancelled Bookings", route: '/', isActive: false },
];

export default function Dashboard() {
  const [analyticBoxtData, setAnalyticBoxData] = useState(initialData);

  const [searchText, setSearchText] = useState<string>("");
  const [loading, setLoading] = useState<any>(true);

  const [selectedTab, setSelectedTab] = useState<string>("enquiry");
  const [tabData, setTabData] = useState<any>([]);

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);

  // useEffect(() => {
  //   const getDashCount = async () => {
  //     const data = await getDashboardCount();
  //     if (data.status === 200) {
  //       setAnalyticBoxData(prevState => prevState.map(item => {
  //         switch (item.label) {
  //           case "Total Enquiries":
  //             return { ...item, count: data.result.enq_count || "0" };
  //           case "Total Quotations":
  //             return { ...item, count: data.result.quote_count || "0" };
  //           case "Total Bookings":
  //             return { ...item, count: data.result.booking_count || "0" };
  //           case "Total Pending":
  //             return {
  //               ...item, 
  //               count: `${Number(data.result.pending_discount_count) + Number(data.result.pending_special_req_count)}` || "0" 
  //             };
  //           default:
  //             return item;
  //         }
  //       }));
  //     }
  //   };

  //   getDashCount();
  // }, []);

  useEffect(() => {
    fetchData(searchText);
    scrollToTop();
    return () => {
      debouncedFetchData.cancel();
    };
  }, [selectedTab, currentPage]);

  const handleSearchChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearchText(value);
    debouncedFetchData(value);
  };

  const debouncedFetchData = useMemo(() => {
    return debounce((searchValue) => {
      fetchData(searchValue);
    }, 400);
  }, [selectedTab]);

  const fetchData = async (searchText: string) => {
    setLoading(true);
    const data = await getDashboardTabsData(selectedTab, searchText, currentPage);
    if (data?.status === 200) {
      setTabData([...data?.result?.result]);
      setTotalPages(data?.result?.total_pages || data?.result?.totalPages);
    }
    setLoading(false);
  };

  const handleTabClick = (tabName: string) => {
    setTabData([]);
    setCurrentPage(1);
    setTotalPages(1);
    setLoading(true);
    setSelectedTab(tabName);
  }

  return (
    <>
      <div className="relative h-full dashboard-wrapper">
        <div className=" w-full h-full mb-4 text-nowrap">
          <Row>
            {analyticBoxtData?.map((item, index) => {
              return (
                <React.Fragment key={index}>
                  <Col>
                    <AnalyticBox item={item} setAnalyticBoxData={setAnalyticBoxData} setSelectedTab={setSelectedTab} />
                  </Col>
                </React.Fragment>  
              );
            })}
          </Row>
          <Row className="my-5 border bg-white rounded m-h-[483px] w-100 m-0">
            <Col className="py-6 px-4" style={{ fontWeight: "700", fontSize: "22px", lineHeight: "28.64px" }}>
              <div className="flex justify-between flex-wrap gap-2">
                <h4>Recent Business Interactions</h4>
                {<div className="flex items-center gap-2 w-1/2 search-global-cont">
                  <SearchIconSvg/>
                  <input
                    autoComplete="off"
                    className="w-100 search-global"
                    placeholder={`Search by ${selectedTab[0].toUpperCase()+selectedTab.slice(1)} Number, Customer Name, Email , Phone Number`}
                    name={"search"}
                    onChange={handleSearchChange}
                    value={searchText}
                  />
                </div>}
              </div>
              <div className="flex gap-3 mt-3 mb-4 dash-nav">
                <div className={`cursor-pointer ${selectedTab === "enquiry" ? "active" : "text-muted"}`} onClick={() => handleTabClick("enquiry")}>Enquiry</div>
                <div className={`cursor-pointer ${selectedTab === "quotation" ? "active" : "text-muted"}`} onClick={() => handleTabClick("quotation")}>Quotation</div>
                <div className={`cursor-pointer ${selectedTab === "booking" ? "active" : "text-muted"}`} onClick={() => handleTabClick("booking")}>Booking</div>
              </div>
              {selectedTab === "enquiry" && (!!tabData.length ?
                <>{tabData?.map((item: any, index: number) => {
                  return <React.Fragment key={index}><EnquiryTableRow item={item} /></React.Fragment>;
                })}</> : <p className="text-center my-2 text-muted">{loading ? "Loading..." : "No Enquiries Found"}</p>)}
              {selectedTab === "quotation" && (!!tabData.length ?
                <>{tabData?.map((item: any, index: number) => {
                  return <React.Fragment key={index}><LeadsTableRow item={item} fetchData={()=>fetchData(searchText)} /></React.Fragment>;
                })}</> : <p className="text-center my-2 text-muted">{loading ? "Loading..." : "No Quotations Found"}</p>)}
              {selectedTab === "booking" && (!!tabData.length ?
                <>{tabData?.map((item: any, index: number) => {
                  return <React.Fragment key={index}><BookingTableRow item={item} /></React.Fragment>;
                })}</> : <p className="text-center my-2 text-muted">{loading ? "Loading..." : "No Bookings Found"}</p>)}
              {!!tabData.length && <CustomPagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages}/>}
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
}
